import { Component, OnInit, Input } from '@angular/core';
import { Incidence } from '../../../models/Incidence';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { ModalController, Platform } from '@ionic/angular';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { MaintenanceService } from '../../../services/commons/maintenance.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { FileSharer } from '@byteowls/capacitor-filesharer';

@Component({
  selector: 'app-incidence-detail',
  templateUrl: './incidence-detail.component.html',
  styleUrls: ['./incidence-detail.component.scss'],
})
export class IncidenceDetailComponent implements OnInit {
  @Input('failure') failure: Incidence;
  public user: string;

  constructor(
    public translate: TranslateConfigService,
    private modalCtrl: ModalController,
    public gms: GlobalMethodsService,
    public gvs: GlobalVariablesService,
    public platform: Platform,
    public maintenanceService: MaintenanceService
  ) { }

  ngOnInit() {
    this.user = this.gvs.user.userName;
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Detalle Incidencia', contentGroup: 'Mantenimientos'});
  }
  
  async downloadFailureReport(failure: Incidence) {
    let base64Incidence = await this.maintenanceService.gAppuserSvrqViewDownload(this.user, failure.request_num);
    if (base64Incidence === undefined) {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.downloadReportKo'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      return;
    }
    this.gms.analyticsTrackEvent('failure_action', { eventCategory: 'SICOR/Descarga Incidencia', eventAction: 'Accion/Descarga Incidencia Inicio', eventLabel: failure.request_num });
    let contentType = 'application/pdf';
    let format = '.pdf';
    let base64Data = base64Incidence;
    FileSharer.share({
      filename: 'ReporteIncidenciaSICOR-' + failure.request_num + format,
      base64Data,
      contentType
    })
  }

  dismiss(value) {
    this.modalCtrl.dismiss({result: value});
  }

}
